var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "time" }, [
    _c("div"),
    _vm._v(" "),
    _c("div", { staticClass: "now_time" }, [
      _c("span", { staticClass: "date_time" }, [
        _vm._v(_vm._s(_vm.year_month))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "bg" }, [_vm._v(_vm._s(_vm.now_date.H))]),
      _vm._v(" :\n        "),
      _c("span", { staticClass: "bg" }, [_vm._v(_vm._s(_vm.now_date.M))]),
      _vm._v(" :\n        "),
      _c("span", { staticClass: "bg" }, [_vm._v(_vm._s(_vm.now_date.S))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d35cc19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d35cc19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/main_content/map/baseMap/time.vue
// module id = null
// module chunks = 